import { useEffect } from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const DEFAULT_CENTER: [number, number] = [-25.4284, -49.2733]; // Curitiba

// Pino via divIcon (HTML/CSS) — evita o problema de carregamento do ícone padrão do Leaflet.
const pinIcon = L.divIcon({
  className: '',
  html: `<div style="width:20px;height:20px;border-radius:999px;background:#dc2626;border:3px solid #fff;box-shadow:0 0 0 2px rgba(0,0,0,0.25);"></div>`,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

const round6 = (n: number) => Math.round(n * 1e6) / 1e6;

function ClickHandler({ onPick }: { onPick: (lat: number, lng: number) => void }) {
  useMapEvents({
    click(e) {
      onPick(round6(e.latlng.lat), round6(e.latlng.lng));
    },
  });
  return null;
}

function Recenter({ lat, lng }: { lat: number; lng: number }) {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], map.getZoom() < 14 ? 16 : map.getZoom());
  }, [lat, lng]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

interface Props {
  lat?: number;
  lng?: number;
  onChange: (lat: number, lng: number) => void;
}

export default function LocationPicker({ lat, lng, onChange }: Props) {
  const hasCoords =
    typeof lat === 'number' &&
    Number.isFinite(lat) &&
    typeof lng === 'number' &&
    Number.isFinite(lng) &&
    !(lat === 0 && lng === 0);

  const center: [number, number] = hasCoords ? [lat as number, lng as number] : DEFAULT_CENTER;

  return (
    <div className="rounded-lg overflow-hidden border border-gray-200 dark:border-dark-border">
      <MapContainer
        center={center}
        zoom={hasCoords ? 16 : 12}
        style={{ height: 280, width: '100%' }}
        scrollWheelZoom
      >
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClickHandler onPick={onChange} />
        {hasCoords && (
          <>
            <Recenter lat={lat as number} lng={lng as number} />
            <Marker
              position={[lat as number, lng as number]}
              icon={pinIcon}
              draggable
              eventHandlers={{
                dragend: (e) => {
                  const p = (e.target as L.Marker).getLatLng();
                  onChange(round6(p.lat), round6(p.lng));
                },
              }}
            />
          </>
        )}
      </MapContainer>
      <div className="bg-gray-50 dark:bg-dark-bg-tertiary text-xs text-gray-500 dark:text-dark-text-secondary px-2 py-1">
        Clique no mapa ou arraste o pino para definir a posição exata.
      </div>
    </div>
  );
}
